import { gql } from '@apollo/client';

export const GET_REPORT_LIST = gql`
query DQgetReportList($primaryReportId: Int) {
    DQgetReportList(primaryReportId: $primaryReportId) {
    id
    name
    hasPeriod
    periodData {
        period
        label
        dataSource
    }
    dataSource
    commonMdrm
  }
}
`;

export const GET_COMMON_REPORT_LIST = gql`
query DQgetReportList($primaryReportId: Int) {
    DQgetReportList(primaryReportId: $primaryReportId) {
    id
    name
    hasPeriod
    periodData {
        period
        label
        dataSource
    }
    dataSource
    commonMdrm
  }
}
`;

export const GET_ITEM_CODES = gql`
query DQgetItemCodes($primaryReportId: Int!, $relatedReportIds: [Int]!) {
  DQgetItemCodes(primaryReportId: $primaryReportId, relatedReportIds: $relatedReportIds) {
    itemCode
    reportCount
  }
}
`;

export const COMPARE_MDRM = gql`
query DQcompareMdrm($primaryReport: ReportPeriod, $relatedReports: [ReportPeriod], $itemCodes: [String]) {
  DQcompareMdrm(primaryReport: $primaryReport, relatedReports: $relatedReports, itemCodes: $itemCodes) {
    itemCode
    itemDescription
    mdrmDetails {
      lineItem
      mdrm
      reportName
      schedule
      value
    }
  }
}
`;

export const GET_REPORT_SOURCE = gql`
query DQgetReportSource($tenantId: Int!, $reportId: Int!, $reportPeriod: String) {
  DQgetReportSource(tenantId: $tenantId, reportId: $reportId, reportPeriod: $reportPeriod) {
    batchList {
      batchId
      startDate
      submitter
    }
    currentBatchId
    currentFileName
    currentSource
    ruleEnabled
  }
}
`;

export const DOWNLOAD_COMPARE_MDRM_RESULT = gql`
query DQdownloadResult($primaryReport: ReportPeriod, $relatedReports: [ReportPeriod], $itemCodes: [String], $format: String!) {
  DQdownloadResult(primaryReport: $primaryReport, relatedReports: $relatedReports, itemCodes: $itemCodes, format: $format) {
    fileName
    fileUrl
  }
}
`;

export const DOWNLOAD_REPORT_TEMPLATE = gql`
query DQdownloadTemplate($reportId: Int!) {
  DQdownloadTemplate(reportId: $reportId) {
    fileName
    fileUrl
  }
}
`;
